import {
  AfterViewInit,
  Directive,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  inject,
} from '@angular/core';
import { MatOption, MatSelect } from '@angular/material/select';
import { Subscription, filter } from 'rxjs';

@Directive({
  selector: 'mat-option[selectAll]'
})
export class SelectAllDirective implements AfterViewInit, OnChanges, OnDestroy {
  @Input({ required: true }) allValues: any[] = [];// combobox items
  @Input({ required: true }) valueField: string = '';// item value property name

  private _matSelect = inject(MatSelect);// the mat-select where the mat-option has this directive applied to
  private _matOption = inject(MatOption);// the mat-option that the directive is applied to

  private _subscriptions: Subscription[] = [];

  private parentSelect = this._matSelect; // the combobox component
  private parentFormControl = this.parentSelect.ngControl.control; // the parent control of the related option where this directive is used
  private allValuesIds: any[] = [];// selected values

  ngAfterViewInit(): void {
    this.allValuesIds = this.allValues.map(v => v[this.valueField]);

    // For changing other option selection based on select all
    this._subscriptions.push(
      // on select all checkbox selection change
      this._matOption.onSelectionChange.subscribe((ev) => {
        if (ev.isUserInput) {
          setTimeout(() => {
            if (ev.source.selected) {
              this.parentFormControl?.setValue(this.allValuesIds);
              this._matOption.select(false);
            } else {
              this.parentFormControl?.setValue([]);
              this._matOption.deselect(false);
            }
          });
        }
      })
    );

    // For changing select all based on other option selection
    this._subscriptions.push(
      // on any checkbox other than "select all" selection change
      this.parentSelect.optionSelectionChanges.subscribe((v) => {
        if (v.isUserInput && v.source.value !== this._matOption.value) {
          if (!v.source.selected) {
            this._matOption.deselect(false);
          } else {
            setTimeout(() => {
              if (this.parentFormControl?.value.length === this.allValuesIds.length) {
                this._matOption.select(false);
              }
            });
          }
        }
      })
    );

    // If user has kept all values selected in select's form-control from the beginning (on first data binding)
    setTimeout(() => {
      if (this.parentFormControl?.value.length === this.allValuesIds.length) {
        this._matOption.select(false);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const allValuesChanges: any = changes['allValues'];// either all values or filtered values due to search result

    if (allValuesChanges && Array.isArray(allValuesChanges.currentValue)) {
      this.allValuesIds = allValuesChanges.currentValue.map((v: any) => v[this.valueField]);

      if (this.parentFormControl?.value?.length === this.allValuesIds.length) {
        this._matOption.select(false);
      }
      else {
        this._matOption.deselect(false);
      }
    }
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach((s) => s.unsubscribe());
  }
}
